import { render, staticRenderFns } from "./tw_search.vue?vue&type=template&id=05d58005&"
import script from "./tw_search.vue?vue&type=script&lang=js&"
export * from "./tw_search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports